import { render } from "./DiscipleEmmaius.vue?vue&type=template&id=ef9772d2&scoped=true&ts=true"
import script from "./DiscipleEmmaius.vue?vue&type=script&lang=ts"
export * from "./DiscipleEmmaius.vue?vue&type=script&lang=ts"

import "./DiscipleEmmaius.vue?vue&type=style&index=0&id=ef9772d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef9772d2"]])

export default __exports__